import { required, helpers } from '@vuelidate/validators'
import { isBirthday as isBirthDayValidator } from './custom-validators'
export const birthday = {
  required,
  isBirthday: helpers.withParams(
    { type: 'isBirthday' },
    isBirthDayValidator
  )
}
